import { useQuery } from "@apollo/client/react";
import type { ResultOf } from "@graphql-typed-document-node/core";
import { useMemo } from "react";
import type { Options } from "react-select";

import { graphql } from "../../gql";
import {
  type DropdownOption,
  type LoadingPreference,
  transformLoadingPreferenceOption,
} from "../utils/optionTransformers";
import type { QueryResult } from "./types/QueryResult";

const loadingPreferenceQuery = graphql(/*GraphQL*/ `
  query LoadingPreferenceQuery($routeCode: String!) {
    viewer {
      loadingPreferences(routeCode: $routeCode) {
        items {
          label
          value
        }
      }
    }
  }
`);
export const loadingPreferenceDropdownNoOption: DropdownOption<LoadingPreference> =
  {
    data: { label: "None", value: "null" },
    label: "None",
    value: "null",
  };

const transformOptions = (
  data: ResultOf<typeof loadingPreferenceQuery> | undefined,
): Options<DropdownOption<LoadingPreference>> => [
  loadingPreferenceDropdownNoOption,
  ...(data?.viewer?.loadingPreferences?.items ?? []).map((p) =>
    transformLoadingPreferenceOption(p),
  ),
];

export const useLoadingPreferenceOptions = (
  routeCode: string | null | undefined,
  skip: boolean = false,
): QueryResult<Options<DropdownOption<LoadingPreference>>> => {
  const { data, loading, error } = useQuery(loadingPreferenceQuery, {
    fetchPolicy: "cache-first",
    variables: { routeCode: routeCode! },
    skip: !routeCode || skip,
  });

  return useMemo(
    () => [transformOptions(data), loading, error],
    [data, error, loading],
  );
};
